import { css } from '@emotion/react';

export const promotionModalConfig = {
  cssStyle: css`
    padding: 16px;
  `,
  hasHeader: false,
  hasFooter: false,
  hasCloseIcon: false,
  isBottomRadius: true,
  isSmallScreen: true
};
